import moment from 'moment-timezone'
import React from 'react'
import { ExtendLocales } from 'src/enums'
import { getLocaleInfo } from 'src/localization/locales'
import { translateNode } from 'src/localization/translateNode'

const compareStringArrayElementLengths = (
  arr1: string[],
  arr2: string[],
): boolean => {
  return (
    arr1
      .map((str) => str.length !== arr2[arr1.indexOf(str)].length)
      .filter((val) => val).length > 0
  )
}

export const validDate = (
  val: string | undefined,
): React.ReactElement | undefined => {
  return val !== undefined &&
    val.trim().length !== 0 &&
    moment(val, 'MM/YY').isValid()
    ? undefined
    : translateNode('Must be a valid date')
}

// TODO: figure out a way to account for all date formats so we're not duplcating functions
export const stringIsDate =
  (locale?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const data = val?.split('/')
    const localeDateFormat = getLocaleInfo(
      locale || ExtendLocales.enUS,
    ).dateFormat.split('/')

    if (
      data === undefined ||
      compareStringArrayElementLengths(data, localeDateFormat) ||
      !moment(
        val,
        getLocaleInfo(locale || ExtendLocales.enUS).dateFormat,
      ).isValid()
    ) {
      return translateNode('Must be of the form ${dateFormat}', {
        dateFormat: getLocaleInfo(locale || ExtendLocales.enUS).dateFormat,
      })
    }

    return undefined
  }

export const stringIsShortDate =
  (locale?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const data = val?.split('/')
    const localeDateFormat = getLocaleInfo(
      locale || ExtendLocales.enUS,
    ).shortDateFormat.split('/')

    if (
      data === undefined ||
      compareStringArrayElementLengths(data, localeDateFormat) ||
      !moment(
        val,
        getLocaleInfo(locale || ExtendLocales.enUS).shortDateFormat,
      ).isValid()
    ) {
      return translateNode('Must be of the form ${dateFormat}', {
        dateFormat: getLocaleInfo(locale || ExtendLocales.enUS).shortDateFormat,
      })
    }

    return undefined
  }

export const stringIsDateInFuture =
  (locale?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const currentDate = moment().startOf('day')
    const inputDate = moment(
      val,
      getLocaleInfo(locale || ExtendLocales.enUS).dateFormat,
    )

    return inputDate.isAfter(currentDate)
      ? undefined
      : translateNode('Must be in the future')
  }

export const stringIsShortDateInFuture =
  (locale?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const currentDate = moment().startOf('month')
    const inputDate = moment(
      val,
      getLocaleInfo(locale || ExtendLocales.enUS).shortDateFormat,
    )

    return inputDate.isAfter(currentDate)
      ? undefined
      : translateNode('Must be in the future')
  }
